export default {
    "title": "Technicals sheets / {{client}}",
    "filters": {
        "materialType": "Type of material",
        "material": "Material",
        "description": "Description",
        "technicalSheetNumber": "AC code",
        "diameter": "Diameter (cm)",
        "height": "Height (mm)",
        "zbot": "Canister",
        "ztap": "Covers",
        "zaux": "Plugs",
        "all": "All"
    },
    "technicalsSheetsHeader": "<0>{{count}}</0> technical sheets found",
    "technicalsSheetsZBotHeader": "<0>{{count}}</0> canisters found",
    "technicalsSheetsZTapHeader": "<0>{{count}}</0> covers found",
    "technicalsSheetsZAuxHeader": "<0>{{count}}</0> plugs found",
    "technicalsSheetsTableColumns": {
        "material": "Material",
        "description": "Description",
        "codeAC": "AC code",
        "packingStandard": "Packing standard",
        "diameter": "Diameter (cm)",
        "height": "Height (mm)",
        "download": "Download (PDF)"
    },
    "nameCollection": "technicals sheets"
}